import { productGroupConstants } from "../constants";

const initialState = {
    loading: false,
    list: [],
    page: null,
    success_msg: null,
    dropdown: []
}

export default function productGroupReducer(state = initialState, { type, response }) {
    switch (type) {
        case productGroupConstants.GET_PRODUCT_GROUPS:
            return {
                ...state,
                loading: true
            }
        case productGroupConstants.GET_PRODUCT_GROUPS_SUCCESS:
            return {
                ...state,
                loading: false,
                list: response?.data?.content || [],
                page: response?.data || null
            }
        case productGroupConstants.GET_PRODUCT_GROUPS_FAILURE:
            return {
                ...state,
                loading: false
            }
        case productGroupConstants.CREATE_PRODUCT_GROUP_SUCCESS:
        case productGroupConstants.UPDATE_PRODUCT_GROUP_SUCCESS:
        case productGroupConstants.CHANGE_PRODUCT_GROUP_STATUS_SUCCESS:
        case productGroupConstants.DELETE_PRODUCT_GROUP_SUCCESS:
        case productGroupConstants.ASSIGN_PRODUCTS_TO_SUBGROUP_SUCCESS:
            return {
                ...state,
                success_msg: response
            }
        case productGroupConstants.GET_PRODUCT_GROUP_DROPDOWN_SUCCESS:
            return {
                ...state,
                dropdown: response?.data || []
            }
        case productGroupConstants.CLEAR_PRODUCT_GROUP_MSG:
            return {
                ...state,
                success_msg: null
            }
        default:
            return state;
    }
}
